import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Seguidores',
  fields: {
    name: 'Nombre:',
    email: 'Correo:',
    phone_number: 'Teléfono:',
    subscribed: 'Suscrito:',
    birthday: 'Cumpleaños:',
    location: 'Ubicación:',
    followed: 'Seguido:',
    lifetime_spent: 'Total gastado:',
    total_orders: 'Pedidos totales:',
    google_review: 'Reseña en Google:',
    loyalty_lifetime: 'Fidelidad total:',
    loyalty_points: 'Fidelidad hoy:',
  },
  labels: {
    yes: 'Sí',
    no: 'No',
    followed_since_date: 'Desde {{date}}',
  },
  buttons: {
    edit: 'Editar',
    request_data_deletion: 'Solicitar eliminación de datos',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
  },
  tabs: {
    recent_orders: {
      title: 'Pedidos recientes',
      columns: {
        order_id: 'Id',
        items: 'Artículos',
        total: 'Importe total',
        paid_on: 'Pagado el',
        payment_method: 'Método de pago',
      },
      labels: {
        no_orders: 'Aún no hay pedidos',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Tarjeta',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Débito bancario',
        [PaymentMethods.CASH]: 'Efectivo',
        [PaymentMethods.BACS_DEBIT]: 'Débito bancario',
      },
    },
    messages: {
      title: 'Mensajes',
      columns: {
        template: 'Plantilla',
        status: 'Estado',
        opened: 'Abierto',
        clicked: 'Clicado',
        spam_complaint: 'Queja de spam',
        unsubscribed: 'Cancelado',
        sent_at: 'Enviado el',
      },
      labels: {
        yes: 'Sí',
        no: 'No',
        not_detected: 'No detectado',
        opened_at: 'Abierto el {{date}}',
        clicked_at: 'Clicado el {{date}}',
        complained_at: 'Reclamado el {{date}}',
        unsubscribed_at: 'Cancelado el {{date}}',
        no_messages: 'Sin mensajes aún',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Enviado',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Entregado',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Fallido',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Error al cargar datos',
      },
    },
    balance_history: {
      title: 'Historial de saldo',
      columns: {
        created_at: 'Fecha',
        source: 'Fuente',
        value: 'Puntos',
        points_expire_at: 'Vence el',
      },
      labels: {
        source: {
          welcome_bonus: 'Bono de bienvenida',
          google_review_reward: 'Recompensa por reseña en Google',
          reward_loyalty_program_conversion: 'Recompensa por conversión al programa de fidelidad',
          cashback: 'Cashback',
          refund: 'Reembolso',
          cashback_usage: 'Uso de cashback',
          cashback_usage_refund: 'Reembolso de uso de cashback',
          expired_points_void: 'Anulación de puntos expirados',
          mobile_app_signup_bonus: 'Bono de registro en la app móvil',
        },
        no_operations: 'Sin operaciones aún',
      },
    },
  },
};
